import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { DashboardData } from '../../../services/dashboard.service';
import { formatDashboardCurrency } from '../dashboard-utils';

@Component({
  selector: 'app-dash-kpi-pending',
  templateUrl: './dash-kpi-pending.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
  styles: [':host { display: block; height: 100%; }']
})
export class DashKpiPendingWidgetComponent {
  data = input<DashboardData | null>(null);
  readonly formatCurrency = formatDashboardCurrency;
}
